<template>
     <v-form
          ref="form"
          v-model="ui.valid"
          lazy-validation
          @submit.prevent="register()"
     >
          <v-row>
               <v-col cols="12 mb-8">
                    <div class="d-flex align-center">
                         <v-btn
                              fab
                              text
                              class="elevation-2 mr-3"
                              small
                              @click="$router.go(-1)"
                         >
                              <v-icon>
                                   mdi-arrow-left
                              </v-icon>
                         </v-btn>
                         <h1>
                              Crear cuenta
                         </h1>
                    </div>

                    <span>
                         ¿Ya tiene cuenta?
                         <router-link :to="{ name: 'Login' }">
                              Iniciar sesión
                         </router-link>
                    </span>
               </v-col>

               <template v-if="!ui.success">
                    <v-col cols="12" class="pb-0 pt-0">
                         <v-text-field
                              clearable
                              outlined
                              label="RFC"
                              autocomplete="off"
                              v-model="layout.rfc"
                              :rules="[v.required, v.rfc]"
                              @keydown.enter="register()"
                         ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                         <v-text-field
                              clearable
                              outlined
                              type="email"
                              autocomplete="off"
                              v-model="layout.email"
                              label="Correo electrónico"
                              :rules="[v.required, v.email]"
                              @keydown.enter="register()"
                         ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                         <v-text-field
                              clearable
                              outlined
                              label="Contraseña"
                              autocomplete="off"
                              v-model="layout.password"
                              :rules="[v.required]"
                              :type="ui.showPassword ? 'text' : 'password'"
                              :append-icon="
                                   ui.showPassword ? 'mdi-eye-off' : 'mdi-eye'
                              "
                              @click:append="ui.showPassword = !ui.showPassword"
                              @keydown.enter="register()"
                         ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                         <v-text-field
                              clearable
                              outlined
                              label="Contraseña (confirmación)"
                              autocomplete="off"
                              v-model="layout.password_confirmation"
                              :rules="[v.required]"
                              :type="ui.showPassword ? 'text' : 'password'"
                              :append-icon="
                                   ui.showPassword ? 'mdi-eye-off' : 'mdi-eye'
                              "
                              @click:append="ui.showPassword = !ui.showPassword"
                              @keydown.enter="register()"
                         ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pb-0">
                         <v-btn
                              color="primary"
                              large
                              @click="register()"
                              :disabled="!ui.valid"
                              :loading="ui.storing"
                              :block="$vuetify.breakpoint.smAndDown"
                         >
                              enviar
                         </v-btn>
                    </v-col>
               </template>
               <template v-else>
                    <v-row>
                         <v-col cols="12">
                              <v-alert type="success" text prominent>
                                   <div class="d-flex flex-column ml-3">
                                        <h3>
                                             ¡Correcto!
                                        </h3>
                                        <p>
                                             Tu cuenta fué creada correctamente.
                                        </p>
                                        <router-link
                                             tag="div"
                                             :to="{ name: 'Login' }"
                                        >
                                             <v-btn color="success">
                                                  Iniciar sesión
                                             </v-btn>
                                        </router-link>
                                   </div>
                              </v-alert>
                         </v-col>
                    </v-row>
               </template>
          </v-row>
     </v-form>
</template>

<script>
import { EventBus } from "@/main";
import axios from "axios";
import Validations from "@/../../GeneralComponents/Validations";

export default {
     data() {
          return {
               v: Validations,

               layout: {
                    acount_type_id: 2,
                    rfc: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
               },

               ui: {
                    valid: true,
                    storing: false,
                    success: false,
                    showPassword: false,
               },
          };
     },

     methods: {
          async register() {
               if (this.$refs.form.validate()) {
                    try {
                         this.ui.storing = true;

                         let response = await axios.post(
                              `${process.env.VUE_APP_API_SERVER}/user`,
                              this.layout
                         );

                         this.ui.success = true;
                    } catch (error) {
                         EventBus.$emit("Error", {
                              error: error,
                              errorsShow: true,
                         });
                    }

                    this.ui.storing = false;
               }
          },
     },
};
</script>

<style lang="css" scoped></style>
